import moment from "moment";

export function splitWordOnCamelCase(word: string) {
    return word.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export function getMoneyFormat(amount: number) {
    return amount.toLocaleString('en-IE', {
        style: 'currency',
        currency: 'EUR'
    });
};

export function getMoneyFormatNoFractions(amount: number) {
    return amount.toLocaleString('en-IE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0 
    });
};

export function reverseMoneyFormat(formattedAmount: string) : string {
    const numericString = formattedAmount.replace(/[^\d.-]/g, '');
    return numericString;
};

export function getMoneyFormatInteger(amount: number) : string {
    if (amount >= 1_000_000) {
        const millions = amount / 1_000_000;
        return `${millions.toFixed(millions % 1 === 0 ? 0 : 1)}m`;
    } else if (amount >= 1_000) {
        const thousands = amount / 1_000;
        return `${thousands.toFixed(thousands % 1 === 0 ? 0 : 1)}k`;
    }

    return amount.toLocaleString('en-IE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

export function getInitials(name: string) {
    if (!name) return '';

    const words = name.trim().split(' ');
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }
    return words.map(w => w.charAt(0).toUpperCase()).join('');
};
export function getEnumKeys<
    T extends string,
    TEnumValue extends string | number,
>(enumVariable: { [key in T]: TEnumValue }) {
    
    for(var m in enumVariable){
        console.log(Object.keys(enumVariable) as Array<T>);
    }
    return Object.keys(enumVariable) as Array<T>;
}

export function getEnumString(enumValue: any, actualEnum: any) {
    var item = Object.keys(actualEnum).find(key => actualEnum[key] === enumValue) || "Invalid value";

    //console.log("enum value, actualEnum", item);
    return Object.keys(actualEnum).find(key => actualEnum[key] === enumValue) || "Invalid value";
}

export function stringToDateFormat(value: string) {
    return !value ? "" : moment(value).format('YYYY-MM-DD');
}

export function getFormattedTimezoneOffset() {
    // Create a new Date object for the current time
    const date = new Date();

    // Get the timezone offset in minutes
    const offsetInMinutes = -date.getTimezoneOffset();

    // Calculate hours and minutes from the offset
    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const minutes = Math.abs(offsetInMinutes) % 60;

    // Format the offset with leading zeros
    const formattedOffset =
        `${offsetInMinutes >= 0 ? '+' : '-'}${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}`;

    return formattedOffset;
}

export function breakLine(line: string) {
    line.split("\n").join("\n");
    return line;
} 

export function replaceNewlinesWithBreak(inputString: string) {
    return inputString.replace(/\n/g, "<br />");
}

export function replaceSpaceAndGetEnumValue(name: string, enumName: any): number | undefined {
    const formattedKey = name.replace(/\s+/g, '');
    return (enumName as any)[formattedKey];
};